import { BarChartByProps } from '../config';
import { useCallback } from 'react';
import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import {
  getSelfTestCategory,
  getSelfTestCategoryIds,
} from '@customer/shared/utils/translationHelpers';
import { useTranslation } from 'react-i18next';
import { ScenarioDataSetLabelV2, ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { GetTooltipTitle } from '../utils';
import { CustomBarChartLabel, OnCategorySelect } from '../bar-select/BarSelectPlugin';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { saveFilters, setFaultCategories } from '@customer/store/slices/filtersSlice';
// import { isEnumValue } from "@customer/shared/utils/typeHelpers";
// import { FaultLevel } from "@customer/store/slices/globalSlice";
// import { FilterGroup } from "@customer/filters/types";

// TODO: Re-enable the commented code after the UX for bar segment selection has been improved.

export const BarChartByFaultCategory = <T extends ScenarioQueryParams>(props: BarChartByProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const siteId = useAppSelector(state => state.auth.siteId);

  const getFaultCategoryLabel = useCallback(
    (label: ScenarioDataSetLabelV2) => {
      return getSelfTestCategory(t, label.id);
    },
    [t],
  );

  const getTooltipTitle = useCallback<GetTooltipTitle>(
    (_, categoryLabelKey) => {
      return getSelfTestCategory(t, Number(categoryLabelKey));
    },
    [t],
  );

  const onCategorySelect = useCallback<OnCategorySelect>(
    ({ id: faultCategoryId }: CustomBarChartLabel): void => {
      if (siteId && getSelfTestCategoryIds().includes(faultCategoryId)) {
        dispatch(setFaultCategories([faultCategoryId]));
        dispatch(saveFilters(siteId));
      }
    },
    [dispatch, siteId],
  );

  // const onBarSelect = useCallback<OnBarSelect>(({ id: faultCategoryId }: CustomBarChartLabel, datasetId: string): void => {
  //   if (siteId && getSelfTestCategoryIds().includes(faultCategoryId)) {
  //     dispatch(setFaultCategories([faultCategoryId]));

  //     // Optionally filter by fault level if the filter group allows it.
  //     if (props.filterGroup === FilterGroup.AssetSelfTest && isEnumValue(datasetId, FaultLevel)) {
  //       dispatch(setFaultLevels([datasetId]));
  //     }

  //     dispatch(saveFilters(siteId));
  //   }
  // }, [dispatch, siteId, props.filterGroup]);

  return (
    <BarChartScenario<T>
      {...props}
      getTooltipTitle={getTooltipTitle}
      getCategoryLabel={getFaultCategoryLabel}
      onCategorySelect={onCategorySelect}
      // Temporarily use the same function for onBarSelect until the UX is improved.
      onBarSelect={onCategorySelect}
    />
  );
};

export default BarChartByFaultCategory;
